<template>
    <div id="left-bar-printing">
        <ul>
            <li class="menu-title text-center">
                <i class="fa fa-print"></i>
                {{ $t("LeftBarPrinting.printing") }}
            </li>

            <li class="has_sub active">
                <router-link to="/printing/dashboard" class="waves-effect active">
                    <i class="fa fa-chart-line"></i>
                    <span> {{ $t("LeftBarPrinting.dashboard") }} </span>
                </router-link>
            </li>
        </ul>
        <div class="clearfix"></div>
    </div>
</template>

<script>
export default {
    name: "LeftBarPrinting",
};
</script>

<style lang="scss">
    @import "../../../assets/scss/colors";

    #left-bar-printing {
        .waves-effect {
            &.active {
                border-left-color: $printing-color;
                i {
                    color: $printing-color;
                }
            }
            .waves-ripple {
                background-color: rgba($printing-color, 0.45) !important;
            }
        }
    }

</style>